import PendingDocumentsToast from './PendingDocumentsToast';

export default PendingDocumentsToast;
